import {create} from 'zustand'
import type {LangT} from '@freckle/educator-entities/ts/common/helpers/languages'
import {Languages} from '@freckle/educator-entities/ts/common/helpers/languages'

export type LanguageSetting = {
  code: LangT
  fromUrl: boolean
}

type SettingsState = {
  langSetting: LanguageSetting
}

const defaultSettingsState: SettingsState = {
  langSetting: {
    code: Languages.En,
    fromUrl: false
  }
}

type Actions = {
  setLanguage: (languageSetting: LanguageSetting) => void
}

export const useSettingsStore = create<SettingsState & Actions>()(set => ({
  ...defaultSettingsState,
  setLanguage: (langSetting: LanguageSetting) => set(_ => ({langSetting}))
}))
